import React, {Component} from 'react';
import Modal from 'simple-react-modal';
import startCase from 'lodash/startCase';
import {getStatusImages, getStatusLabel} from '../../utils';
import { Link } from 'react-router';
import MADarkLogo from '../../../html/assets/images/motoamerica-dark.png';
import MADarkLogo2x from '../../../html/assets/images/motoamerica-dark@2x.png';
import {CREDENTIAL_TYPE_LABELS} from '../../constants';


class PassItemModal extends Component {

  state = {};

  showModal = () => {
    this.setState({show: true})
  };

  hideModal = () => {
    this.setState({show: false})
  };

  cancelCredentialWithWarning = (id) => {
    if (confirm("Do you really want to cancel this credential?")) {
      this.props.cancelCredential(id)
    } else {
      console.log("Do nothing")
    }
  };

  render() {
    const {item: {credentialID, credentialType, status}} = this.props;
    return (
      <Modal
        style={{background: '#2C2F63'}} //overwrites the default background
        containerStyle={{background: '#2C2F63'}} //changes styling on the inner content area
        closeOnOuterClick={true}
        show={this.state.show}
        onClose={this.hideModal}
      >
        <div className="modal modal-credential" style={{display: 'inherit'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <ModalHeader hideModal={this.hideModal}/>
              <ModalBody {...this.props} />
              <ModalFooter
                credentialID={credentialID}
                credentialType={credentialType}
                status={status}
                cancelCredential={this.cancelCredentialWithWarning}
              />
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

const ModalHeader = (props) => (
  <div className="modal-header">
    <a className="pull-left" aria-label="Close" onClick={props.hideModal}>
      <span aria-hidden="true">
        <div className="icon-white_close panel-cta"></div>
      </span>
    </a>
  </div>
);

const ModalBody = ({name, schedule, trackName, item}) => {
  const {status, credentialType, firstName, lastName, photoUrl, lastUpdated, startDate, endDate, round} = item;
  const [statusImage, statusImage2x] = getStatusImages(status.toLowerCase());

  if (round === 'manually-assigned-credentials') {
    schedule = `${startDate} - ${endDate}`;
  }

  return (
    <div className="modal-body">
      <div className="panel panel-card panel-card-lg">
        <div className={`panel-heading card-brand card-${credentialType} text-center`}>
          <h3 className="panel-title">
            {CREDENTIAL_TYPE_LABELS[credentialType] ? CREDENTIAL_TYPE_LABELS[credentialType]["singluar"] : ''}
          </h3>
        </div>

        <div className="panel-body text-center">
          <div data-track={trackName}></div>
          <h5>{name}</h5>
          <strong>{schedule}</strong>
        </div>

        <div className="panel-footer">
          <img src={MADarkLogo}
               srcSet={`${MADarkLogo} 1x, ${MADarkLogo2x} 2x`}
               alt="motoamerica logo" className="card-stamp"/>
          <div className="media">
            {(credentialType === 'season' || credentialType === 'season_paddock' || credentialType === 'season_media') && <ProfilePic url={photoUrl} />}
            <div className="media-body">
              <span className="h4">{firstName} {lastName}</span>
              <br />
              <span>
                <img src={statusImage} srcSet={`${statusImage} 1x, ${statusImage2x} 2x`} alt={status}/>
                {' '}
                {startCase(getStatusLabel(status))}
              </span>
            </div>
          </div>
        </div>
      </div>

      <strong>{startCase(getStatusLabel(status))}</strong>
      <br />
      {lastUpdated}
      <hr />
    </div>
  );
};

const ProfilePic = ({url}) => (
  <div className="pull-left">
    <img src={`${url}-/preview/40x40/`} srcSet={`${url}-/preview/40x40/ 1x, ${url}-/preview/80x80/ 2x`} alt="user pic"/>
  </div>
);

const ModalFooter = ({credentialID, credentialType, status, cancelCredential}) => {
  const cancelButton = status.toLowerCase() === "approved" ?
    <Link to="/help" className="pull-left">Request Cancel</Link> :
    <a onClick={() => cancelCredential(credentialID)} className="btn btn-default-outline pull-left">Cancel</a>;

  const editButtonLink = status.toLowerCase() === "approved" ? "/help" : `/request-form-${CREDENTIAL_TYPE_LABELS[credentialType]["type_link"]}/${credentialID}`;

  return (
    <div className="modal-footer">
      {cancelButton}
      <Link to={editButtonLink} className="btn btn-default-outline">Edit</Link>
    </div>
  );
};

export default PassItemModal;



// WEBPACK FOOTER //
// ./src/components/Credentials/PassItemModal.js